<div class="palette">
  <div class="palette__search">
    <mat-icon class="palette__search-icon">search</mat-icon>
    <input class="palette__search-input" type="text" [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()"
      [placeholder]="'Search fields...' | translate" />
    </div>

    @if (hasLoopScopes) {
      <div class="palette__section palette__section--context">
        <div class="palette__section-title">{{ (contextLabel || 'Table Fields') | translate }}</div>
        @if (contextFieldsView.length > 0) {
          @for (field of contextFieldsView; track trackByPath($index, field)) {
            <div class="palette__field" (click)="insertField(field.path)"
              [title]="field.label">
              <mat-icon class="palette__field-icon">functions</mat-icon>
              <span class="palette__field-label">{{ field.label | translate }}</span>
            </div>
          }
        } @else {
          <div class="palette__hint">
            <mat-icon class="palette__hint-icon">touch_app</mat-icon>
            <span>{{ 'Click inside a repeating table cell to insert its fields' | translate }}</span>
          </div>
        }
      </div>
    }

    @if (boundFieldsView.length > 0) {
      <div class="palette__section">
        <div class="palette__section-title">{{ 'Bound Fields' | translate }}</div>
        @for (field of boundFieldsView; track trackByPath($index, field)) {
          <div class="palette__field" (click)="insertField(field.path)"
            [title]="field.label">
            <mat-icon class="palette__field-icon">data_object</mat-icon>
            <span class="palette__field-label">{{ field.label | translate }}</span>
          </div>
        }
      </div>
    }

    @if (runtimeEntityGroups.length > 0) {
      <div class="palette__section">
        <div class="palette__section-title">{{ 'Runtime Fields' | translate }}</div>
        @for (group of runtimeEntityGroups; track trackByEntity($index, group)) {
          <div [style.--entity-accent]="group.accent">
            <div class="palette__section-subtitle" (click)="toggleEntity(group.key)">
              <span class="palette__section-subtitle-label">{{ group.label | translate }}</span>
              <span class="palette__entity-right">
                <span class="palette__entity-count">{{ group.fields.length }}</span>
                <mat-icon class="palette__entity-chevron" [class.expanded]="group.expanded">chevron_right</mat-icon>
              </span>
            </div>
            <div class="palette__entity-rows" [@detailExpand]="group.expanded ? 'expanded' : 'collapsed'">
              @for (field of group.fields; track trackByPath($index, field)) {
                <div class="palette__field palette__field--indented" (click)="insertField(field.path)"
                  [title]="field.label">
                  <mat-icon class="palette__field-icon">functions</mat-icon>
                  <span class="palette__field-label">{{ field.label | translate }}</span>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }

    @if (filteredFields.length === 0) {
      <div class="palette__empty">
        <mat-icon>search_off</mat-icon>
        <span>{{ 'No fields found' | translate }}</span>
      </div>
    }
  </div>
